import React from 'react'
import ReactDOM from 'react-dom'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import App from './App'
import GlobalStyle from './styles/globalStyles'
import theme from './styles/theme'

ReactDOM.render(
	<>
		<HelmetProvider>
			<ThemeProvider theme={theme}>
				<GlobalStyle />
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</ThemeProvider>
		</HelmetProvider>
	</>,
	document.getElementById('root')
)
